<div [ngClass]="{'has-errors': hasErrors}">
  <boi-validation-error-generic [validationErrors]="validationErrors" [propertyNames]="validationPropertyNames">
  </boi-validation-error-generic>
  <kendo-textbox-container>
    <div [ngClass]="cssClasses" class="field-container">
      <div class="field-label" *ngIf="labelName" [boiRequiredFormField]="required ? labelName : undefined">
        <div class="label-content">
          <label [for]="controlId ? controlId : labelName" [innerHtml]="labelName | localizeLabel"></label>
          <ng-content></ng-content>
        </div>
        <boi-tooltip *ngIf="showTooltip && !isTooltipLast" [tooltipName]="tooltipName ? tooltipName : labelName">
        </boi-tooltip>
      </div>
      <div class="field-input">
        <kendo-timepicker [id]="controlId ? controlId : labelName" [placeholder]="placeholder" [format]="format"
          [min]="min" [max]="max" (blur)="onBlur()" [(ngModel)]="value" [disabled]="isFieldDisabled">
        </kendo-timepicker>
      </div>
      <boi-tooltip *ngIf="showTooltip && isTooltipLast" [tooltipName]="tooltipName ? tooltipName : labelName">
      </boi-tooltip>
    </div>
  </kendo-textbox-container>
</div>
